import { BadgeCheck, CreditCard, Home, ShieldCheck, Shirt, Tractor } from "lucide-react";
import { WHY } from "@/data/site";
import { Eyebrow, Reveal } from "./Reveal";
import { Leaves } from "./Leaves";

const ICONS = { BadgeCheck, CreditCard, Home, ShieldCheck, Shirt, Tractor };

export const WhyUs = () => (
  <section data-testid="why-section" className="grain relative overflow-hidden bg-[var(--leaf-deep)] py-24 text-white sm:py-32">
    <Leaves count={8} opacity={0.35} />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow light>Why HF</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-black leading-[0.95] sm:text-6xl">Small enough to care. <span className="font-serif-i font-normal text-[#bfe3bf]">Equipped to deliver.</span></h2>
      </Reveal>
      <div className="mt-16 grid gap-px overflow-hidden rounded-3xl bg-white/15 sm:grid-cols-2 lg:grid-cols-3">
        {WHY.map((w, i) => {
          const Icon = ICONS[w.icon];
          return (
            <Reveal key={w.title} delay={i * 0.06} className="group bg-[var(--leaf-deep)] p-8 transition-colors duration-500 hover:bg-[#145a19]" data-testid={`why-${i}`}>
              <div className="flex items-start justify-between">
                <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white/10 transition-[background-color,transform] duration-500 group-hover:-rotate-6 group-hover:bg-white group-hover:text-[var(--leaf)]">
                  <Icon className="h-6 w-6" />
                </span>
                <span className="font-serif-i text-2xl text-white/40">0{i + 1}</span>
              </div>
              <h3 className="mt-10 font-display text-2xl font-bold leading-tight">{w.title}</h3>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
